/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherAttachment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OtherAttachment({
  children,
  viewPath = "/DesignSystem/CommsThreadEventAttachments/Content/Attachment/OtherAttachment",
  value
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let attachmentNameValueData = fromData.useDataValue({ viewPath,
context: 'attachment',
path: 'name',
})
  return (<React.Fragment
>
<a
 href={value} rel='noopener noreferrer' target='_blank'
  data-testid="OtherAttachment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 marginTop={dtSpaceXs}
 maxWidth={150}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="attachment.name"
 text={attachmentNameValueData}
/>
)}
</TysiaTag>
</a>
{children}
</React.Fragment>)
}